<template>
  <div>
    <div v-if="field.before" v-html="field.before"></div>

    <div v-if="field.fillable !== false">              
      <div v-if="field.type == 'championchip'">
        <div>
          <div class="form-check">
            <input class="form-check-input" @change="handleChange" type="radio" :id="'product-' + product.id + '-cc-own'" v-model="val['cc']" value="own" :disabled="state == 'complete'">
            <label class="form-check-label" for="inlineRadio0">Ich besitze einen Championchip</label>
          </div>
          <input v-if="val['cc'] === 'own'" @input="handleChange" type="text" class="form-control my-3" :placeholder="field.placeholder" v-model="val[field.id]" :disabled="state == 'complete'">
          <div class="form-check">
            <input class="form-check-input" @change="handleChange" type="radio" :id="'product-' + product.id + '-cc-rent'" v-model="val['cc']" value="rent" :disabled="state == 'complete'">
            <label class="form-check-label" for="inlineRadio1">Ich möchte einen Championchip mieten (muss nach der Veranstaltung zurückgegeben werden)</label>
          </div>
          <!-- <div class="form-check">
            <input class="form-check-input" type="radio" :id="'product-' + product.id + '-cc-buy'" v-model="val['cc']" value="buy" :disabled="state == 'complete'">
            <label class="form-check-label" for="inlineRadio2">Ich möchte einen Championchip kaufen</label>
          </div> -->
        </div>
      </div>
      <div v-else-if="field.type == 'select'">
        <label for="">{{ field.label }}</label>
        <select class="form-control" :placeholder="field.placeholder" v-model="val[field.id]" @change="handleChange" :disabled="state == 'complete'">
          <option :value="undefined" disabled selected>{{ field.label }} auswählen</option>
          <option v-for="option of field.options" :value="option.id" :key="option.id" :disabled="option.disabled">
            {{ option.label }}
            <span v-if="option.limit !== undefined"> ({{ option.count }} / {{ option.limit }})</span>
          </option>
        </select>
      </div>
      <div v-else-if="field.type == 'checkbox'">
        <div class="form-check">
          <input type="checkbox" :id="'product-' + product.id + '-' + field.id" @change="handleChange" class="form-check-input" v-model="val[field.id]" :disabled="state == 'complete'">
          <label :for="'product-' + product.id + '-' + field.id" class="form-check-label" v-html="field.label"></label>
        </div>
      </div>
      <div v-else>
        <label for="">{{ field.label }}</label>
        <input type="text" class="form-control" :placeholder="field.placeholder" @input="handleChange" v-model="val[field.id]" :disabled="state == 'complete'">
      </div>
    </div><!-- v-if field.fillable -->

    <div v-if="field.after" v-html="field.after"></div>
  </div>
</template>

<script>
import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
  name: 'Field',
  props: [
    'field',
    'product',
    'state',
    'onChange',
    'value',
  ],
  watch: {
    value: function(newVal) {
      // this.onChange(newVal, this.product)
      this.val[this.field.id] = newVal
    }
  },
  data: function() {
    return {
      val: {},
    }
  },
  methods: {
    handleChange: function (event) {
      var newVal = event.target.type === 'checkbox' ? event.target.checked : event.target.value
      var args = {}
      args[this.field.id] = newVal
      this.val[this.field.id] = newVal
      if (this.field.id === 'championchip') {
        args['cc'] = this.val['cc'] || '';
        if (args['championchip'] === 'own' && args['cc'] === 'own') {
          this.val['championchip'] = '';
        }
      }
      this.onChange(args, this.product)
    }
  }
}
</script>